export default class FaunaActions {
  static NEW_DATA = "NEW_DATA";
  static UPDATE_DATA = "UPDATE_DATA";
  static SHOW_DATA = "SHOW_DATA";
  static VIEW_DATA = "VIEW_DATA";
  static DELETE_DATA = "DELETE_DATA";
  static ON_SUBMIT = "ON_SUBMIT";
  static ERROR_DATA = "ERROR_DATA";
  static PROCESS_DATA = "PROCESS_DATA";
  static RESET_DATA = "RESET_DATA";
  static SUCCESS_DATA = "SUCCESS_DATA";
  static ERROR_SERVER = "ERROR_SERVER";
  static submit() {
    return {
      type: FaunaActions.ON_SUBMIT,
    };
  }

  static create(data) {
    return {
      type: FaunaActions.NEW_DATA,
      payload: data,
    };
  }

  static update(data) {
    return {
      type: FaunaActions.UPDATE_DATA,
      payload: data,
    };
  }

  static view(data) {
    return {
      type: FaunaActions.VIEW_DATA,
      payload: data,
    };
  }

  static delete(data) {
    return {
      type: FaunaActions.DELETE_DATA,
    };
  }

  static list(data) {
    return {
      type: FaunaActions.SHOW_DATA,
      payload: data,
    };
  }
  static error(error) {
    return {
      type: FaunaActions.ERROR_DATA,
      payload: error,
    };
  }
  static success() {
    return {
      type: FaunaActions.SUCCESS_DATA,
    };
  }
  static process() {
    return {
      type: FaunaActions.PROCESS_DATA,
    };
  }
  static reset() {
    return {
      type: FaunaActions.RESET_DATA,
    };
  }
  //   static getHelper(data){
  //     return{
  //       type : FaunaActions.GET_HELPER_AccSetup,
  //       payload : data
  //     };

  //   }
  static errorInternal(error) {
    return {
      type: FaunaActions.ERROR_SERVER,
      payload: error,
    };
  }
}
